<script lang="ts">
  // Libs
  import { goto } from "@roxi/routify";

  // Stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // Components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import SavedForLaterSection from "@retailer/svelte/Cart/SavedForLater/Section.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // Types
  import type { SavedProductDict } from "@shared/types/SavedProducts";

  // Props
  export let cartService;
  export let callbacks;
  export let savedProducts: SavedProductDict;
  export let savedProductsCount: number;

  const goToHomepage = () => $goto("/");
</script>

<style>
  .empty-cart-icon {
    background-color: #f5f7f7;
    height: 64px;
    width: 64px;
  }
</style>

<div class="fizz-surface-gray" class:fizz-inset-squish-64={$layoutStore.isDesktop}>
  <div class="fizz-container fizz-flex-row fizz-surface fizz-justify-center fizz-text-center">
    <div class="fizz-inset-square-32">
      <div class="fizz-inset-square-32">
        <div class="fizz-inset-square-32">
          <div class="fizz-flex-row fizz-justify-center fizz-stack-12">
            <div
              class="fizz-radius-round empty-cart-icon fizz-flex-row fizz-justify-center fizz-align-self-center"
            >
              <Icon
                type="Cart"
                centered
                width={32}
                height={32}
                color={"#848484"}
                id="empty-cart-icon"
              />
            </div>
          </div>
          <div class="fizz-flex-row fizz-justify-center fizz-stack-12">
            <div>
              <h2 class="fizz-heading-2 fizz-align-self-center">Your cart is empty</h2>
              <p class="fizz-text-large fizz-align-self-center">
                Add items to your cart to send an order
              </p>
            </div>
          </div>
          <div class="fizz-flex-row fizz-justify-center">
            <button on:click={goToHomepage} class="fizz-button-secondary"> Go to homepage </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

{#if savedProductsCount > 0}
  <div class="fizz-container fizz-flex-row">
    <div style="flex-grow: 3">
      <SavedForLaterSection
        {cartService}
        {callbacks}
        {savedProducts}
        isMobile={$layoutStore.isMobile}
      />
    </div>
  </div>
{/if}
